import { TableColumn } from "@/components/Table/Table";

import { TItem } from "@/components/SortableList/SortableList";

/**
 * Turn the tracker table's live columns into the persisted column-configuration entries
 * (order, visibility, lock state) that `table-config` stores per tracker.
 */
export const buildTableConfigEntries = (columns: TableColumn[]): TItem[] =>
	columns.map((column, index) => ({
		uid: column.uid ?? "",
		id: index + 1,
		show: typeof column.show !== "undefined" ? column.show : true,
		content: column.title,
		locked: !!column.locked || false,
		allowExclude: typeof column.allowExclude !== "undefined" ? column.allowExclude : true,
		custom: column.uid?.includes("custom-") || false,
		columnId: column.uid?.includes("custom-") ? +column.uid.split("-")[1] : undefined,
		moveable: column.moveable,
		hideable: column.hideable,
		svgIcon: column.svgIcon?.toString(),
	}));

/**
 * Shallow, order-sensitive comparison of two persisted configurations — used to skip the PUT when
 * the rebuilt configuration is identical to the stored one.
 */
export const areTableConfigEntriesEqual = (
	current: Record<string, unknown>[],
	stored: Record<string, unknown>[]
): boolean => {
	if (current?.length !== stored?.length) {
		return false;
	}

	return current.every((entry, index) => {
		const other = stored[index];

		if (!other) {
			return false;
		}

		return Object.keys(entry).every((key) => entry[key] === other[key]);
	});
};
